// This component is now merged into Experience component
// Keeping this file for backward compatibility
function Education() {
  return null;
}

export default Education;
